export const MESSAGES = {
  NOTE_NOT_FOUND: 'Nota no encontrada',
  REQUEST_ERROR: 'Error en la petición',
};
